import React from "react";
import { rhythm } from "../utils/typography";
import Header from "./Header";
import Footer from "./Footer";
import "./layout.css";

const Layout = ({ location, title, children }) => {
  // const rootPath = `${__PATH_PREFIX__}/`
  if (typeof document !== `undefined`) {
    window.onscroll = function () {
      var navBar = document.getElementById("nav-links");
      // console.log("window" + window.pageYOffset);
      // console.log("nav" + navBar.offsetTop);
      if (window.pageYOffset >= 100) {
        console.log("add");
        navBar.classList.add("nav-sticky");
      } else {
        console.log("remove");
        navBar.classList.remove("nav-sticky");
      }
    };
  }
  return (
    <div
      style={{
        marginLeft: `auto`,
        marginRight: `auto`,
        maxWidth: rhythm(36),
        padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
      }}
      id="div-main"
    >
      <header id="nav-links" className="header-main-nav">
        <Header location={location} />
      </header>
      <main className="content-main">{children}</main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};

export default Layout;
